import { z } from 'zod';

import { PaymentId } from '../BrandedIds';
import { zodBrandedUuid, zodDateOrString } from '../utils/Zod';
import { BaseLoanEvent } from './BaseLoanEvent';

export const ProcessUsioSameDayAchEvent = BaseLoanEvent.extend({
  type: z.literal('processUsioSameDayAch'),
  paymentId: zodBrandedUuid<PaymentId>(),
  timestamp: zodDateOrString,
  batch: z.string(),
});
export type ProcessUsioSameDayAchEvent = z.infer<typeof ProcessUsioSameDayAchEvent>;
